"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fees = function Fees() {
  return _react2.default.createElement(
    "g",
    { id: "fees" },
    _react2.default.createElement("path", {
      d: "M463.039536,0 L463.039536,498.807089 L392.913429,431.57805 L322.276074,499.318337 L252.235174,432.259714 L182.875937,498.721881 L110.619632,429.533061 L37,500 L37.8520791,0.681663258 L463.039536,0 Z M143.509884,79.4989775 C128.768916,79.4989775 116.925017,91.4280845 116.925017,106.083845 C116.925017,120.739605 128.854124,132.668712 143.509884,132.668712 L356.529652,132.668712 C371.27062,132.668712 383.114519,120.739605 383.114519,106.083845 C383.114519,91.4280845 371.185412,79.4989775 356.529652,79.4989775 L143.509884,79.4989775 Z M143.509884,186.008862 C128.768916,186.008862 116.925017,197.937969 116.925017,212.593729 C116.925017,227.334697 128.854124,239.263804 143.509884,239.263804 L356.529652,239.263804 C371.27062,239.263804 383.114519,227.334697 383.114519,212.593729 C383.114519,197.852761 371.185412,186.008862 356.529652,186.008862 L143.509884,186.008862 Z M143.509884,292.518746 C128.768916,292.518746 116.925017,304.447853 116.925017,319.103613 C116.925017,333.759373 128.854124,345.68848 143.509884,345.68848 L250.019768,345.68848 C264.760736,345.68848 276.604635,333.759373 276.604635,319.103613 C276.604635,304.447853 264.675528,292.518746 250.019768,292.518746 L143.509884,292.518746 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Fees;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Fees.js
// module id = 2949
// module chunks = 4